import React from "react";
import { SEARCH } from "../../../core/theme/searchTheme";
import { SAMPLE_COUNTS, SAMPLE_SPACINGS } from "../../../core/data/scanPlan";

// Samples per search: how many times, and how far apart.
export default function SamplesSection({ form }) {
  const { samples, setSamples, spacing, setSpacing } = form;

  return (
    <div>
      <div className={SEARCH.sectionHeader}>
        <span className={SEARCH.sectionTitle}>Samples per search</span>
      </div>
      <div className="flex items-center gap-2">
        <div className={SEARCH.segmentGroup}>
          {SAMPLE_COUNTS.map(n => (
            <button key={n} onClick={() => setSamples(n)} className={samples === n ? SEARCH.segmentActive : SEARCH.segment}>{n}</button>
          ))}
        </div>
        <span className="text-xs text-slate-400">every</span>
        <div className={SEARCH.segmentGroup}>
          {SAMPLE_SPACINGS.map(s => (
            <button key={s.id} onClick={() => setSpacing(s.id)} className={spacing === s.id ? SEARCH.segmentActive : SEARCH.segment}>{s.label}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
